import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { Grid, Typography, Button, Box, MenuItem, Select } from '@material-ui/core';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import InfoIcon from '@material-ui/icons/Info';
import MaterialTable from 'material-table';
import useStyles from '../../Main.style';
import useDashboard from '../../../../hooks/useDashboard';
import useImport from '../../../../hooks/useImport';
import useCalendarEvents from '../../../../hooks/useCalendarEvents'; /* eslint-disable-next-line */
import FinancialProgression from './../FinancialProgression/FinancialProgression'; /* eslint-disable-next-line */
import MyGoals from './../MyGoals/MyGoals';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover';

const MyPerformanceTab = () => {
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  const bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const userId = loggedInUserData?.id;
  const departmentId = loggedInUserData?.departmentId;
  const cellId = loggedInUserData?.cellId;
  let calendarEventsData = {};
  const currentYear = new Date().getFullYear();
  const [endPeriod, setEndPeriod] = useState('Full Year');
  const [performanceYear, setPerformanceYear] = useState(currentYear);
  const [myInvoicingPerformanceData, setMyInvoicingPerformanceData] = useState(
    [],
  ); /* eslint-disable-next-line */
  const [adminClosedData, setAdminClosedData] = useState([]);
  const [finanacialCompensationData, setFinanacialCompensationData] = useState([]);
  const [loggedInUserDetails, setLoggedInUserDetails] = useState([]);
  const [myProfessionalQuarterlyGoal, setMyProfessionalQuarterlyGoal] = useState([]);
  const [myLogiwareData, setMyLogiwareData] = useState([]);
  const [activeAdminClosedData, setActiveAdminClosedData] = useState([]);
  const [activeAdminClosedDataFullYear, setActiveAdminClosedDataFullYear] = useState([]);
  const [activeAdminClosedDataJanJune, setActiveAdminClosedDataJanJune] = useState([]);
  const [activeAdminClosedDataJulyDec, setActiveAdminClosedDataJulyDec] = useState([]);
  const [activeAdminClosedDataPastSixMonths, setActiveAdminClosedDataPastSixMonths] = useState([]);
  const [optimalData, setOptimalData] = useState([]);
  const [optimalDataFullYear, setOptimalDataFullYear] = useState([]);
  const [optimalDataJanJune, setOptimalDataJanJune] = useState([]);
  const [optimalDataJulyDec, setOptimalDataJulyDec] = useState([]);
  const [optimalDataPastSixMonths, setOptimalDataPastSixMonths] = useState([]);
  const [activeAdminData, setActiveAdminData] = useState([]);
  const [activeAdminDataFullYear, setActiveAdminDataFullYear] = useState([]);
  const [activeAdminDataJanJune, setActiveAdminDataJanJune] = useState([]);
  const [activeAdminDataJulyDec, setActiveAdminDataJulyDec] = useState([]);
  const [activeAdminDataPastSixMonths, setActiveAdminDataPastSixMonths] = useState([]);

  const endPeriodOptions = [
    'Full Year',
    'January - June',
    'July - December',
    'Past 6 Months Rolling',
  ];

  const getAvailableMonths = () => {
    let dataToUse = optimalData?.default || [];

    if (
      endPeriodOptions[0] === 'Full Year' &&
      optimalDataFullYear &&
      optimalDataFullYear['Full Year']
    ) {
      dataToUse = optimalDataFullYear['Full Year'];
    } else if (
      endPeriodOptions[1] === 'January - June' &&
      optimalDataJanJune &&
      optimalDataJanJune['January - June']
    ) {
      dataToUse = optimalDataJanJune['January - June'];
    } else if (
      endPeriodOptions[2] === 'July - December' &&
      optimalDataJulyDec &&
      optimalDataJulyDec['July - December']
    ) {
      dataToUse = optimalDataJulyDec['July - December'];
    } else if (
      endPeriodOptions[3] === 'Past 6 Months Rolling' &&
      optimalDataPastSixMonths &&
      optimalDataPastSixMonths['Past 6 Months Rolling']
    ) {
      dataToUse = optimalDataPastSixMonths['Past 6 Months Rolling'];
    }

    const availableMonths = dataToUse?.map(({ month }) => month);
    return availableMonths;
  };

  const {
    getRecentAnnouncements,
    getMyQuarterlyGoal,
    getMyInvoicingPerformance,
    getMyLogiwareDetails,
    getAdminClosedDelta,
    getOptimalInvoiceData,
    getActiveAdminDelta,
  } = useDashboard();

  const { getFinancialCompensationDataByEmailId } = useImport();
  const { getCalendarEventsForWeek } = useCalendarEvents();

  const availableMonthsData = getAvailableMonths();
  const getMonthlyActiveAdminChartData = () => {
    const monthlyActiveAdminChartData = Array(12).fill(0);

    let dataToUse = null;

    if (
      endPeriodOptions[0] === 'Full Year' &&
      activeAdminDataFullYear &&
      activeAdminDataFullYear['Full Year']
    ) {
      dataToUse = activeAdminDataFullYear['Full Year'];
    } else if (
      endPeriodOptions[1] === 'January - June' &&
      activeAdminDataJanJune &&
      activeAdminDataJanJune['January - June']
    ) {
      dataToUse = activeAdminDataJanJune['January - June'];
    } else if (
      endPeriodOptions[2] === 'July - December' &&
      activeAdminDataJulyDec &&
      activeAdminDataJulyDec['July - December']
    ) {
      dataToUse = activeAdminDataJulyDec['July - December'];
    } else if (
      endPeriodOptions[3] === 'Past 6 Months Rolling' &&
      activeAdminDataPastSixMonths &&
      activeAdminDataPastSixMonths['Past 6 Months Rolling']
    ) {
      dataToUse = activeAdminDataPastSixMonths['Past 6 Months Rolling'];
    } else {
      dataToUse = activeAdminData?.default || [];
    }

    dataToUse.forEach(({ month, activeAdminDelta, maxData }) => {
      monthlyActiveAdminChartData[month - 1] = { activeAdminDelta, maxData }; // Month is 1-based, array index is 0-based
    });

    return monthlyActiveAdminChartData;
  };

  const getAvailableActiveAdminMonths = () => {
    let dataToUse = activeAdminData?.default || [];

    if (
      endPeriodOptions[0] === 'Full Year' &&
      activeAdminDataFullYear &&
      activeAdminDataFullYear['Full Year']
    ) {
      dataToUse = activeAdminDataFullYear['Full Year'];
    } else if (
      endPeriodOptions[1] === 'January - June' &&
      activeAdminDataJanJune &&
      activeAdminDataJanJune['January - June']
    ) {
      dataToUse = activeAdminDataJanJune['January - June'];
    } else if (
      endPeriodOptions[2] === 'July - December' &&
      activeAdminDataJulyDec &&
      activeAdminDataJulyDec['July - December']
    ) {
      dataToUse = activeAdminDataJulyDec['July - December'];
    } else if (
      endPeriodOptions[3] === 'Past 6 Months Rolling' &&
      activeAdminDataPastSixMonths &&
      activeAdminDataPastSixMonths['Past 6 Months Rolling']
    ) {
      dataToUse = activeAdminDataPastSixMonths['Past 6 Months Rolling'];
    }

    const availableMonths = dataToUse?.map(({ month }) => month);
    return availableMonths;
  };
  const activeAdminClosedMonthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const activeAdminMonthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const monthlyActiveAdminChartData = getMonthlyActiveAdminChartData();
  const availableActiveAdminMonths = getAvailableActiveAdminMonths();
  const activeAdmincategories = availableMonthsData?.map(
    (month) => activeAdminMonthNames[month - 1],
  );

  const getMonthlyChartData = () => {
    const monthlyChartData = Array(12).fill(0);
    let dataToUse = null;

    if (
      endPeriodOptions[0] === 'Full Year' &&
      optimalDataFullYear &&
      optimalDataFullYear['Full Year']
    ) {
      dataToUse = optimalDataFullYear['Full Year'];
    } else if (
      endPeriodOptions[1] === 'January - June' &&
      optimalDataJanJune &&
      optimalDataJanJune['January - June']
    ) {
      dataToUse = optimalDataJanJune['January - June'];
    } else if (
      endPeriodOptions[2] === 'July - December' &&
      optimalDataJulyDec &&
      optimalDataJulyDec['July - December']
    ) {
      dataToUse = optimalDataJulyDec['July - December'];
    } else if (
      endPeriodOptions[3] === 'Past 6 Months Rolling' &&
      optimalDataPastSixMonths &&
      optimalDataPastSixMonths['Past 6 Months Rolling']
    ) {
      dataToUse = optimalDataPastSixMonths['Past 6 Months Rolling'];
    } else {
      dataToUse = optimalData?.default || [];
    }

    dataToUse.forEach(({ month, optimalInvoiceDelta, maxData }) => {
      monthlyChartData[month - 1] = { optimalInvoiceDelta, maxData }; // Month is 1-based, array index is 0-based
    });

    return monthlyChartData;
  };

  const activeAdminDeltaOptions = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: activeAdmincategories,
      labels: { rotation: 0 }, // Keep x-axis labels horizontal
    },
    yAxis: {
      title: {
        text: 'Average Days',
      },
    },
    series: [
      {
        name: 'My Performance',
        data: availableActiveAdminMonths?.map(
          (month) => monthlyActiveAdminChartData[month - 1]?.activeAdminDelta || 0,
        ),
        color: '#003C6F',
      },
      {
        name: 'Top Performer',
        data: availableActiveAdminMonths?.map(
          (month) =>
            monthlyActiveAdminChartData[month - 1]?.maxData ||
            monthlyActiveAdminChartData[month - 1]?.activeAdminDelta,
        ),
        color: '#1e601d',
        type: 'line',
        lineWidth: 0, // Hide the line

        marker: {
          symbol:
            'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDEzIDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cmVjdCB3aWR0aD0iMTMiIGhlaWdodD0iNSIgcng9IjIiIGZpbGw9IiMzQ0MxM0IiLz4NCjxyZWN0IHdpZHRoPSIxMyIgaGVpZ2h0PSI1IiByeD0iMiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC41Ii8+DQo8L3N2Zz4NCg==)',
          radius: 0,
          enabled: true,
        },
      },
    ],
  };
  const monthlyChartData = getMonthlyChartData();
  const categories = availableMonthsData?.map((month) => activeAdminClosedMonthNames[month - 1]);
  const chartOptions = {
    chart: { type: 'column', className: 'myChartContainer' }, // Primary chart type
    title: { text: '' },
    xAxis: {
      categories,
      labels: { rotation: 0 }, // Keep x-axis labels horizontal
    },
    yAxis: {
      title: {
        text: 'Average Days',
      },
    },

    series: [
      {
        name: 'My Performance',
        data: availableMonthsData?.map(
          (month) => monthlyChartData[month - 1]?.optimalInvoiceDelta || 0,
        ),
        color: '#003C6F', // Set the color of the column series
        type: 'column', // Specify this series as a column chart
      },

      {
        name: 'Top Performer',
        data: availableMonthsData?.map(
          (month) =>
            monthlyChartData[month - 1]?.maxData ||
            monthlyChartData[month - 1]?.optimalInvoiceDelta,
        ),
        color: '#1e601d',
        type: 'line',
        lineWidth: 0, // Hide the line

        marker: {
          symbol:
            'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDEzIDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cmVjdCB3aWR0aD0iMTMiIGhlaWdodD0iNSIgcng9IjIiIGZpbGw9IiMzQ0MxM0IiLz4NCjxyZWN0IHdpZHRoPSIxMyIgaGVpZ2h0PSI1IiByeD0iMiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC41Ii8+DQo8L3N2Zz4NCg==)',
          radius: 0,
          enabled: true,
        },
      },
    ],
  };

  const getAvailableActiveAdminClosedMonths = () => {
    let dataToUse = activeAdminClosedData?.default || [];

    if (
      endPeriodOptions[0] === 'Full Year' &&
      activeAdminClosedDataFullYear &&
      activeAdminClosedDataFullYear['Full Year']
    ) {
      dataToUse = activeAdminClosedDataFullYear['Full Year'];
    } else if (
      endPeriodOptions[1] === 'January - June' &&
      activeAdminClosedDataJanJune &&
      activeAdminClosedDataJanJune['January - June']
    ) {
      dataToUse = activeAdminClosedDataJanJune['January - June'];
    } else if (
      endPeriodOptions[2] === 'July - December' &&
      activeAdminClosedDataJulyDec &&
      activeAdminClosedDataJulyDec['July - December']
    ) {
      dataToUse = activeAdminClosedDataJulyDec['July - December'];
    } else if (
      endPeriodOptions[3] === 'Past 6 Months Rolling' &&
      activeAdminClosedDataPastSixMonths &&
      activeAdminClosedDataPastSixMonths['Past 6 Months Rolling']
    ) {
      dataToUse = activeAdminClosedDataPastSixMonths['Past 6 Months Rolling'];
    }

    const availableMonths = dataToUse.map(({ month }) => month);
    return availableMonths;
  };

  const getMonthlyActiveAdminClosedChartData = () => {
    const monthlyActiveAdminClosedChartData = Array(12).fill(0);
    let dataToUse = activeAdminClosedData?.default || [];

    if (
      endPeriodOptions[0] === 'Full Year' &&
      activeAdminClosedDataFullYear &&
      activeAdminClosedDataFullYear['Full Year']
    ) {
      dataToUse = activeAdminClosedDataFullYear['Full Year'];
    } else if (
      endPeriodOptions[1] === 'January - June' &&
      activeAdminClosedDataJanJune &&
      activeAdminClosedDataJanJune['January - June']
    ) {
      dataToUse = activeAdminClosedDataJanJune['January - June'];
    } else if (
      endPeriodOptions[2] === 'July - December' &&
      activeAdminClosedDataJulyDec &&
      activeAdminClosedDataJulyDec['July - December']
    ) {
      dataToUse = activeAdminClosedDataJulyDec['July - December'];
    } else if (
      endPeriodOptions[3] === 'Past 6 Months Rolling' &&
      activeAdminClosedDataPastSixMonths &&
      activeAdminClosedDataPastSixMonths['Past 6 Months Rolling']
    ) {
      dataToUse = activeAdminClosedDataPastSixMonths['Past 6 Months Rolling'];
    }

    dataToUse.forEach(({ month, adminClosedDelta, maxData }) => {
      monthlyActiveAdminClosedChartData[month - 1] = { adminClosedDelta, maxData }; // Month is 1-based, array index is 0-based
    });

    return monthlyActiveAdminClosedChartData;
  };

  const availableActiveAdminClosedMonths = getAvailableActiveAdminClosedMonths();
  const monthlyActiveAdminClosedChartData = getMonthlyActiveAdminClosedChartData();
  const activeAdminClosedCategories = availableActiveAdminClosedMonths.map(
    (month) => activeAdminClosedMonthNames[month - 1],
  );
  const handlePerformanceYearChange = (value) => {
    setPerformanceYear(value);
  };

  const fetchOptimalInvoiceData = async () => {
    const response = await getOptimalInvoiceData({ userName: loggedInUserData?.userName }); // Assuming your API endpoint is at '/api'

    setOptimalData(response?.data);
  };

  const fetchActiveAdminData = async () => {
    const response = await getActiveAdminDelta({ userName: loggedInUserData?.userName }); // Assuming your API endpoint is at '/api'
    setActiveAdminData(response?.data);
  };

  const fetchAdminClosedData = async () => {
    const response = await getAdminClosedDelta({ userName: loggedInUserData?.userName }); // Assuming your API endpoint is at '/api'
    setAdminClosedData(response?.data);
  };
  const activeAdminClosedDeltaOptions = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: activeAdminClosedCategories,
      labels: { rotation: 0 }, // Keep x-axis labels horizontal
    },
    yAxis: {
      title: {
        text: 'Average Days',
      },
    },
    series: [
      {
        name: 'My Performance',
        data: availableActiveAdminClosedMonths.map(
          (month) => monthlyActiveAdminClosedChartData[month - 1]?.adminClosedDelta || 0,
        ),
        color: '#003C6F',
      },

      {
        name: 'Top Performer',
        data: availableActiveAdminClosedMonths.map(
          (month) =>
            monthlyActiveAdminClosedChartData[month - 1]?.maxData ||
            monthlyActiveAdminClosedChartData[month - 1]?.adminClosedDelta,
        ),
        color: '#1e601d',
        type: 'line',
        lineWidth: 0, // Hide the line

        marker: {
          symbol:
            'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDEzIDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cmVjdCB3aWR0aD0iMTMiIGhlaWdodD0iNSIgcng9IjIiIGZpbGw9IiMzQ0MxM0IiLz4NCjxyZWN0IHdpZHRoPSIxMyIgaGVpZ2h0PSI1IiByeD0iMiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC41Ii8+DQo8L3N2Zz4NCg==)',
          radius: 0,
          enabled: true,
        },
      },
    ],
  };
  const handleApplyFilter = async () => {
    let responseData = null;

    if (endPeriod === 'Full Year') {
      responseData = await getOptimalInvoiceData({
        year: performanceYear,
        dateRange: 'Full Year',
        userName: loggedInUserData?.userName,
      });
      setOptimalDataFullYear(responseData?.data);
      setOptimalDataJanJune([]);
      setOptimalDataJulyDec([]);
      setOptimalDataPastSixMonths([]);

      responseData = await getActiveAdminDelta({
        year: performanceYear,
        dateRange: 'Full Year',
        userName: loggedInUserData?.userName,
      });
      setActiveAdminDataFullYear(responseData?.data);
      setActiveAdminDataJanJune([]);
      setActiveAdminDataJulyDec([]);
      setActiveAdminDataPastSixMonths([]);

      responseData = await getAdminClosedDelta({
        year: performanceYear,
        dateRange: 'Full Year',
        userName: loggedInUserData?.userName,
      });
      setActiveAdminClosedDataFullYear(responseData?.data);
      setActiveAdminClosedDataJanJune([]);
      setActiveAdminClosedDataJulyDec([]);
      setActiveAdminClosedDataPastSixMonths([]);
    } else if (endPeriod === 'January - June') {
      responseData = await getOptimalInvoiceData({
        year: performanceYear,
        dateRange: 'January - June',
        userName: loggedInUserData?.userName,
      });

      setOptimalDataJanJune(responseData?.data);
      setOptimalDataFullYear([]);
      setOptimalDataJulyDec([]);
      setOptimalDataPastSixMonths([]);

      responseData = await getActiveAdminDelta({
        year: performanceYear,
        dateRange: 'January - June',
        userName: loggedInUserData?.userName,
      });
      setActiveAdminDataJanJune(responseData?.data);
      setActiveAdminDataFullYear([]);
      setActiveAdminDataJulyDec([]);
      setActiveAdminDataPastSixMonths([]);

      responseData = await getAdminClosedDelta({
        year: performanceYear,
        dateRange: 'January - June',
        userName: loggedInUserData?.userName,
      });
      setActiveAdminClosedDataJanJune(responseData?.data);
      setActiveAdminClosedDataFullYear([]);
      setActiveAdminClosedDataJulyDec([]);
      setActiveAdminClosedDataPastSixMonths([]);
    } else if (endPeriod === 'July - December') {
      responseData = await getOptimalInvoiceData({
        year: performanceYear,
        dateRange: 'July - December',
        userName: loggedInUserData?.userName,
      });
      setOptimalDataJulyDec(responseData?.data);
      setOptimalDataFullYear([]);
      setOptimalDataJanJune([]);
      setOptimalDataPastSixMonths([]);

      responseData = await getActiveAdminDelta({
        year: performanceYear,
        dateRange: 'July - December',
        userName: loggedInUserData?.userName,
      });
      setActiveAdminDataJulyDec(responseData?.data);
      setActiveAdminDataFullYear([]);
      setActiveAdminDataJanJune([]);
      setActiveAdminDataPastSixMonths([]);

      responseData = await getAdminClosedDelta({
        year: performanceYear,
        dateRange: 'July - December',
        userName: loggedInUserData?.userName,
      });
      setActiveAdminClosedDataJulyDec(responseData?.data);
      setActiveAdminClosedDataFullYear([]);
      setActiveAdminClosedDataJanJune([]);
      setActiveAdminClosedDataPastSixMonths([]);
    } else if (endPeriod === 'Past 6 Months Rolling') {
      responseData = await getOptimalInvoiceData({
        year: performanceYear,
        dateRange: 'Past 6 Months Rolling',
        userName: loggedInUserData?.userName,
      });
      setOptimalDataPastSixMonths(responseData?.data);
      setOptimalDataFullYear([]);
      setOptimalDataJanJune([]);
      setOptimalDataJulyDec([]);

      responseData = await getActiveAdminDelta({
        year: performanceYear,
        dateRange: 'Past 6 Months Rolling',
        userName: loggedInUserData?.userName,
      });
      setActiveAdminDataPastSixMonths(responseData?.data);
      setActiveAdminDataFullYear([]);
      setActiveAdminDataJanJune([]);
      setActiveAdminDataJulyDec([]);

      responseData = await getAdminClosedDelta({
        year: performanceYear,
        dateRange: 'Past 6 Months Rolling',
        userName: loggedInUserData?.userName,
      });
      setActiveAdminClosedDataPastSixMonths(responseData?.data);
      setActiveAdminClosedDataFullYear([]);
      setActiveAdminClosedDataJanJune([]);
      setActiveAdminClosedDataJulyDec([]);
    } else {
      responseData = await getOptimalInvoiceData({
        year: performanceYear,
        dateRange: endPeriod,
        userName: loggedInUserData?.userName,
      });
      setOptimalData(responseData?.data);

      responseData = await getActiveAdminDelta({
        year: performanceYear,
        dateRange: endPeriod,
        userName: loggedInUserData?.userName,
      });
      setActiveAdminData(responseData?.data);

      responseData = await fetchAdminClosedData({
        year: performanceYear,
        dateRange: activeAdminEndPeriod,
      });
      setActiveAdminClosedData(responseData?.data);
    }
  };

  const loadFinancialCompensationDataByEmailId = async () => {
    const result = await getFinancialCompensationDataByEmailId({
      emailId: loggedInUserData?.emailId,
    });
    if (result) {
      setFinanacialCompensationData(result?.usersResult || []);
    }
  };

  const handleEndPeriodChange = (value) => {
    setEndPeriod(value);
  };

  const loadMyInvoicingPerformance = async () => {
    const myInvoicingPerformance = await getMyInvoicingPerformance({
      userName: loggedInUserData?.userName,
      userId: loggedInUserData?.id,
      countryTitle: loggedInUserData?.country?.countryValue,
    });
    setMyInvoicingPerformanceData(myInvoicingPerformance?.usersResult);
  };
  const loadMyProfessionalQuarterlyGoal = async () => {
    const myProfessionalQuarterlyGoals = await getMyQuarterlyGoal({
      userId,
      partOf: '3',
      type: '1',
      year: '0.25',
    });

    setMyProfessionalQuarterlyGoal(myProfessionalQuarterlyGoals?.data);
  };
  const loadDashboardDetails = async () => {
    const recentAnnouncements = await getRecentAnnouncements(
      departmentId,
      cellId,
      loggedInUserData?.id,
    );
    setLoggedInUserDetails(recentAnnouncements?.usersDetails);
  };
  const loadMyLogiwareDetails = async () => {
    const myLogiwareDetails = await getMyLogiwareDetails({
      userName: loggedInUserData?.userName,
      countryTitle: loggedInUserData?.country?.countryValue,
    });
    setMyLogiwareData(myLogiwareDetails?.usersResult);
  };
  const loadGetCalendarEventsForWeek = async () => {
    if (Object.keys(calendarEventsData).length === 0) {
      calendarEventsData = await getCalendarEventsForWeek();
    }
  };

  useEffect(() => {
    loadFinancialCompensationDataByEmailId(); /* eslint-disable-next-line */
    fetchAdminClosedData(); /* eslint-disable-next-line */
    fetchActiveAdminData(); /* eslint-disable-next-line */
    fetchOptimalInvoiceData(); /* eslint-disable-next-line */
  }, []);

  useEffect(() => {
    loadDashboardDetails(); /* eslint-disable-next-line */
  }, []);

  useEffect(() => {
    loadMyProfessionalQuarterlyGoal(); /* eslint-disable-next-line */
    loadMyInvoicingPerformance(); /* eslint-disable-next-line */
    loadMyLogiwareDetails(); /* eslint-disable-next-line */
  }, []); /* eslint-disable-next-line */
  useEffect(() => {
    loadGetCalendarEventsForWeek(); /* eslint-disable-next-line */
  }, []);

  const classes = useStyles();
  return (
    <>
      <MyGoals myProfessionalQuarterlyGoal={myProfessionalQuarterlyGoal} />
      <If condition={loggedInUserDetails?.department?.departmentTitle !== 'Sales'}>
        <Grid container spacing={4}>
          <Grid item xs={12} className={classes.innercontent}>
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between">
                      <Box mt={1.5}>
                        <Typography variant="h5">Performance Metrics</Typography>
                      </Box>
                      <Box className={classes.CompanyOperationalPerformanceFilter}>
                        <Box>
                          <Select
                            value={performanceYear}
                            onChange={(e) => handlePerformanceYearChange(e.target.value)}
                          >
                            <MenuItem value={null}>--</MenuItem>
                            {Array.from(
                              { length: 5 },
                              (_, i) => new Date().getFullYear() - (4 - i),
                            ).map((year) => (
                              <MenuItem key={year} value={year}>
                                {year}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                        <Box mx={1}>
                          <Typography variant="body1">to</Typography>
                        </Box>
                        <Box>
                          <Select
                            value={endPeriod}
                            onChange={(e) => handleEndPeriodChange(e.target.value)}
                          >
                            {endPeriodOptions.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                        <Box ml={2} style={{ height: '100%' }}>
                          <Button
                            style={{ height: '100%' }}
                            variant="outlined"
                            color="primary"
                            onClick={handleApplyFilter}
                          >
                            Apply
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>

                  <If condition={loggedInUserDetails?.department?.departmentTitle === 'Operations'}>
                    <Grid item xs={12} sm={12} md={6}>
                      <Box className={classes.innercontentWhite}>
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="h5" noWrap>
                            OPTIMAL INVOICE DELTA
                          </Typography>
                        </Box>
                        <Box mt={1}>
                          <Box>
                            <div className={classes.myChartContainer}>
                              <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                            </div>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <Box className={classes.innercontentWhite}>
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="h5" noWrap>
                            ACTIVE TO ADMIN DELTA
                          </Typography>
                        </Box>
                        <Box mt={1}>
                          <Box>
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={activeAdminDeltaOptions}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  </If>

                  <If
                    condition={
                      loggedInUserDetails?.department?.departmentTitle === 'Superadmin' ||
                      loggedInUserDetails?.department?.departmentTitle === 'Administrations'
                    }
                  >
                    <Grid item xs={12} sm={12} md={6}>
                      <Box className={classes.innercontentWhite}>
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="h5" noWrap>
                            ADMIN TO CLOSED DELTA
                          </Typography>
                        </Box>
                        <Box mt={1}>
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={activeAdminClosedDeltaOptions}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  </If>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </If>

      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                      <Box className={classes.innercontentWhite} height="100%">
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="h5" noWrap>
                            INVOICING
                          </Typography>
                          <InfoPopover />
                          <InfoIcon aria-haspopup="true" className={classes.InfoIconStyle} />
                        </Box>
                        <Box mt={1} className={classes.TableUIV2}>
                          <MaterialTable
                            style={{ boxShadow: 'none' }}
                            options={{
                              toolbar: false,
                              draggable: false,
                              paging: false,
                              sorting: true,
                              pageSize: 20,
                              pageSizeOptions: [10, 20, 50, 100],
                              showTextRowsSelected: false,
                              toolbarButtonAlignment: 'right',
                              showFirstLastPageButtons: false,
                              actionsColumnIndex: -100,
                              emptyRowsWhenPaging: false,
                            }}
                            localization={{
                              pagination: {
                                labelRowsSelect: 'Rows',
                                labelRowsPerPage: 'Rows Per Page',
                              },
                            }}
                            title="My Personal Performance INVOICING"
                            columns={[
                              {
                                title: `${loggedInUserData?.firstName ?? ''} ${
                                  loggedInUserData?.lastName ?? ''
                                }`,
                                field: 'cellf',
                                render: (data) => data?.metrix,
                              },
                              {
                                title: 'Ranking',
                                field: 'vectorranking',
                                render: (data) => (
                                  <span
                                    className={
                                      /* eslint-disable-next-line */
                                      data?.vectorRank ===
                                      Math.max(
                                        ...myInvoicingPerformanceData.map((o) => o?.vectorRank),
                                      )
                                        ? classes.vectorRankingRed
                                        : data?.vectorRank === 1
                                        ? classes.vectorRankingGreen
                                        : classes.vectorranking
                                    }
                                  >
                                    {data?.vectorRank}
                                  </span>
                                ),
                              },
                              {
                                title: `${new Date().getFullYear()} Full Year`,
                                field: 'ytd',
                                render: (data) =>
                                  data?.ytd.includes('(') ? (
                                    <Typography className={classes.TableTextRed}>
                                      {data?.ytd}
                                    </Typography>
                                  ) : (
                                    data?.ytd
                                  ),
                              },

                              {
                                title: `${new Date().getFullYear()}  Top Employee`,
                                field: 'bestcell',
                                render: (data) =>
                                  data?.bestCell.includes('(') ? (
                                    <Typography className={classes.TableTextRed}>
                                      {data?.bestCell}
                                    </Typography>
                                  ) : (
                                    data?.bestCell
                                  ),
                              },
                              {
                                title: `${new Date().getFullYear() - 1} Full Year`,
                                field: 'previousyear',
                                render: (data) =>
                                  data?.prevYear.includes('(') ? (
                                    <Typography className={classes.TableTextRed}>
                                      {data?.prevYear}
                                    </Typography>
                                  ) : (
                                    data?.prevYear
                                  ),
                              },
                            ]}
                            data={myInvoicingPerformanceData || []}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <Box className={classes.innercontentWhite} height="100%">
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="h5" noWrap>
                            FILE MANAGEMENT
                          </Typography>
                          <InfoIcon aria-haspopup="true" className={classes.InfoIconStyle} />
                        </Box>

                        <Box mt={1} className={classes.TableUIV2}>
                          <MaterialTable
                            style={{ boxShadow: 'none' }}
                            options={{
                              toolbar: false,
                              draggable: false,
                              paging: false,
                              sorting: true,
                              pageSize: 20,
                              pageSizeOptions: [10, 20, 50, 100],
                              showTextRowsSelected: false,
                              toolbarButtonAlignment: 'right',
                              showFirstLastPageButtons: false,
                              actionsColumnIndex: -100,
                              emptyRowsWhenPaging: false,
                            }}
                            localization={{
                              pagination: {
                                labelRowsSelect: 'Rows',
                                labelRowsPerPage: 'Rows Per Page',
                              },
                            }}
                            title="File Management"
                            columns={[
                              {
                                title: `${loggedInUserData?.firstName} ${loggedInUserData?.lastName}`,
                                field: 'cellf',
                                render: (data) => data?.metrix,
                              },
                              {
                                title: 'Ranking',
                                field: 'vectorranking',
                                render: (data) => (
                                  <span
                                    className={
                                      /* eslint-disable-next-line */
                                      data?.vectorRank ===
                                      Math.max(...myLogiwareData.map((o) => o?.vectorRank))
                                        ? classes.vectorRankingRed
                                        : data?.vectorRank === 1
                                        ? classes.vectorRankingGreen
                                        : classes.vectorranking
                                    }
                                  >
                                    {data?.vectorRank}
                                  </span>
                                ),
                              },
                              {
                                title: `${new Date().getFullYear()} Full Year`,
                                field: 'ytd',
                                render: (data) =>
                                  data?.ytd.includes('(') ? (
                                    <Typography className={classes.TableTextRed}>
                                      {data?.ytd}
                                    </Typography>
                                  ) : (
                                    data?.ytd
                                  ),
                              },

                              {
                                title: `${new Date().getFullYear() - 1} Top Employee`,
                                field: 'bestcell',
                                render: (data) =>
                                  data?.bestCell.includes('(') ? (
                                    <Typography className={classes.TableTextRed}>
                                      {data?.bestCell}
                                    </Typography>
                                  ) : (
                                    data?.bestCell
                                  ),
                              },
                              {
                                title: `${new Date().getFullYear() - 1} Full Year`,
                                field: 'previousyear',
                                render: (data) =>
                                  data?.prevYear.includes('(') ? (
                                    <Typography className={classes.TableTextRed}>
                                      {data?.prevYear}
                                    </Typography>
                                  ) : (
                                    data?.prevYear
                                  ),
                              },
                            ]}
                            data={myLogiwareData || []}
                          />
                        </Box>
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Box className={classes.innercontentWhite}>
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="h5" noWrap>
                            FORMS
                          </Typography>
                        </Box>
                        <MaterialTable
                          style={{ boxShadow: 'none' }}
                          className={classes.materialDT}
                          options={{
                            toolbar: false,
                            draggable: false,
                            paging: false,
                            sorting: true,
                            pageSize: 20,
                            pageSizeOptions: [10, 20, 50, 100],
                            showTextRowsSelected: false,
                            toolbarButtonAlignment: 'right',
                            showFirstLastPageButtons: false,
                            actionsColumnIndex: -100,
                            emptyRowsWhenPaging: false,
                          }}
                          localization={{
                            pagination: {
                              labelRowsSelect: 'Rows',
                              labelRowsPerPage: 'Rows Per Page',
                            },
                          }}
                          title="FORMS"
                          columns={[
                            {
                              title: 'Type of Form',
                              field: 'metric',
                              render: (data) => data.metric,
                            },
                            {
                              title: 'Metric',
                              field: 'myresult',
                              render: (data) => data.myresult,
                            },
                            {
                              title: 'Form',
                              field: 'myrank',
                              render: (data) => data.myrank,
                            },
                          ]}
                          data={[
                            {
                              metric: '360 Peer Review',
                              myresult: '30',
                              myrank: 'Form',
                            },
                            {
                              metric: 'Client Survey',
                              myresult: '30',
                              myrank: 'Form',
                            },
                            {
                              metric: 'Supervisor Score',
                              myresult: '30',
                              myrank: 'Form',
                            },
                          ]}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Box mb={2}>
                <Typography variant="h5">Financial Progression</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} className={classes.innercontentWhite}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <If
                    condition={loggedInUserData?.id !== undefined && loggedInUserData?.id !== null}
                  >
                    <FinancialProgression
                      userId={loggedInUserData?.id}
                      finanacialCompensationData={finanacialCompensationData}
                    />
                  </If>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default MyPerformanceTab;
